import * as Immutable from 'immutable';
import { AccountAction, AccountActionType } from '../_actions/UserAccountActions';
import UserPrefsStore from '../_stores/UserPrefsStore';
import Dinero from 'dinero.js';

const UserPrefsReducer = (store:UserPrefsStore = new UserPrefsStore(), action: AccountAction):UserPrefsStore => {
	switch (action.type) {
		case AccountActionType.EditUserPrefs:
			let {name, lang, currency, newsletter} = action.updates;
			store = store.withMutations((store) => {
				if(name) store = store.set('name', name);
				if(lang) store = store.set('lang', lang);
				if(currency) store = store.set('currency', currency);

				Dinero.globalLocale = store.get('currency') == 'USD' ? 'en-US' : store.get('lang').split('_')[0] + '-CA';

				if(newsletter) store = store.set('newsletter', newsletter);
			});
	}
	return store;
}
export default UserPrefsReducer